module.exports = __webpack_public_path__ + "img/mongo-dark.31918ce8.svg";